import { render, staticRenderFns } from "./ProgressStatementBlockCard.vue?vue&type=template&id=d2ec2044"
import script from "./ProgressStatementBlockCard.vue?vue&type=script&lang=ts"
export * from "./ProgressStatementBlockCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports